// extracted by mini-css-extract-plugin
export default {"container":"MU-z","title":"NU-z","link":"OU-z"};